/** Helpers for building AshGraphql `like`/`ilike` filter patterns from user input. */

/**
 * Escapes a term so `%` and `_` match themselves rather than acting as wildcards. Backslash is
 * Postgres' default `LIKE` escape character, so it needs escaping too and no `ESCAPE` clause is
 * required. Mandark applies the same rule server-side in
 * `Mandark.Accounts.User.Preparations.SearchForAdministration`.
 */
export function escapeLikePattern(value: string): string {
  return value.replace(/[\\%_]/g, (char) => `\\${char}`);
}

/** A `like`/`ilike` pattern matching `term` anywhere in the value, wildcards escaped. */
export function ilikeAnywhere(term: string): string {
  return `%${escapeLikePattern(term)}%`;
}
